import Marquee from "react-fast-marquee";

const ITEMS = [
  "YOUR RIDE.", "YOUR DELIVERY.", "OUR PRIORITY.",
  "RIDES & DELIVERIES.", "WINDSOR, NS.", "24/7 SERVICE.",
];

export const Ribbon = () => (
  <div data-testid="marquee-ribbon" className="bg-ink py-4 border-y-2 border-ink overflow-hidden">
    <Marquee speed={55} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-extrabold text-sun uppercase text-2xl sm:text-4xl tracking-tight mx-6">
            {t}
          </span>
          <span className="text-brandred text-2xl sm:text-4xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
